import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./UserSidebar.css";

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(false);
  let user = { name: "Demo User" };
  try {
    const stored = sessionStorage.getItem("currentUser");
    if (stored) {
      const parsed = JSON.parse(stored);
      if (parsed.role === "user") user = { name: parsed.username };
    } else {
      const local = JSON.parse(localStorage.getItem("user") || "null");
      if (local && local.name) user = local;
    }
  } catch (e) {
    // keep default user
  }

  const toggleSidebar = () => setIsOpen(!isOpen);

  return (
    <>
      {/* Hamburger button for mobile */}
      <button className="hamburger-btn" onClick={toggleSidebar}>
        ☰
      </button>

      <div className={`sidebar ${isOpen ? "open" : ""}`}>
        {/* Sidebar Top */}
        <div className="sidebar-top">
          <h5 className="text-white mb-3">USER</h5>
          <div className="user-box">
            <div className="user-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" viewBox="0 0 16 16">
                <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.029 10 8 10c-2.029 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"/>
              </svg>
            </div>
            <p className="user-name">{user.name}</p>
          </div>
        </div>

        {/* Sidebar Menu */}
        <ul className="sidebar-menu">
          <li>
            <NavLink
              to="/user/user-dashboard"
              className={({ isActive }) => (isActive ? "active" : "")}
              onClick={() => setIsOpen(false)} // close sidebar after click on mobile
            >
              <span className="menu-icon">
                {/* Dashboard SVG */}
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M8 4a.5.5 0 0 1 .5.5v4.793l2.146 2.147a.5.5 0 0 1-.708.708L8 9.207V4.5A.5.5 0 0 1 8 4z" />
                  <path d="M8 0a8 8 0 1 0 8 8A8 8 0 0 0 8 0zm0 1a7 7 0 1 1-7 7 7 7 0 0 1 7-7z" />
                </svg>
              </span>
              Dashboard
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/user/add-complaint"
              className={({ isActive }) => (isActive ? "active" : "")}
              onClick={() => setIsOpen(false)}
            >
              <span className="menu-icon">
                {/* Add Complaint SVG */}
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M8 6.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V11a.5.5 0 0 1-1 0V9.5H6a.5.5 0 0 1 0-1h1.5V7a.5.5 0 0 1 .5-.5z" />
                  <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3-.5a.5.5 0 0 1-.5-.5V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4h-2z" />
                </svg>
              </span>
              Add Complaint
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/user/complaint-status"
              className={({ isActive }) => (isActive ? "active" : "")}
              onClick={() => setIsOpen(false)}
            >
              <span className="menu-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M8 0a8 8 0 1 0 8 8A8 8 0 0 0 8 0zm1 12H7v-1h2v1zm0-2H7V4h2v6z" />
                </svg>
              </span>
              Complaint Status
            </NavLink>
          </li>
        </ul>
      </div>

      {/* Overlay for mobile when sidebar is open */}
      {isOpen && <div className="sidebar-overlay" onClick={toggleSidebar}></div>}
    </>
  );
};

export default Sidebar;
